module.exports = __webpack_public_path__ + "img/greenmasters-banner.2dd85db8.jpg";